class ZonePicker extends HTMLElement {
  constructor() {
    super();
    this.allowedPostCodes = {};
    this.validPostCode = false;

    const postCodesScriptTag = this.querySelector('script[data-list-post-codes]');

    if (postCodesScriptTag && postCodesScriptTag.textContent.trim()) {
      try {
        this.allowedPostCodes = JSON.parse(postCodesScriptTag.textContent.trim());
      } catch (error) {
        console.error('Failed to parse allowed postcodes:', error);
      }
    }

    const productVariantsScriptTag = this.querySelector('script[data-product-variants]')

    if (productVariantsScriptTag && productVariantsScriptTag.textContent.trim()) {
      try {
        this.productVariants = JSON.parse(productVariantsScriptTag.textContent.trim());
      } catch (error) {
        console.error('Failed to parse allowed postcodes:', error);
      }
    } 

    this.fetchTimes()
  }

  connectedCallback() {

    this.stateSelector = this.querySelector('[data-state]');
    this.postcodeInput = this.querySelector('[data-post-code]');
    this.errorMessage = this.querySelector('[data-zone-error]');
    this.suburb = this.querySelector('[data-suburb]');
    this.postcodeDiv = this.querySelector('[data-post-codes]');
    this.suburbSelect = this.querySelector('[data-suburb-select]')
    this.notAvailableMessage = this.querySelector('[data-zone-not-available]')?.innerHTML || '';

    this.productId = document.querySelector('[data-product-id]')
    this.currentVariantInput = this.querySelector('input[name="id"]')
    this.zoneVariantInput = this.querySelector('[data-zone-variant]')
    this.zoneTitleInput = this.querySelector('[data-zone-variant-title]')
    this.zoneIdInput = this.querySelector('[data-zone-variant-id]')
    this.quantityVariant = this.querySelector('[data-variant-quantity]')
    this.quantityOption = this.querySelector('[data-variant-option]')
    this.variantName = this.querySelector('[data-variant-option]')
    this.calendarPickerButton = document.querySelector('[data-calendar-picker]')
    this.confirmButton = document.querySelector('[data-confirm-button]')
    this.confirmAtcButton = document.querySelector('[data-confirm-atc-button]')

    if (this.stateSelector) {
      this.stateSelector.addEventListener('change', this.handleStateChange.bind(this));
    }

    if (this.postcodeInput) {
      this.postcodeInput.addEventListener('input', this.handlePostcodeInput.bind(this));
    }

    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', this.handleConfirmButton.bind(this));
    }

    if (this.quantityVariant) {
      this.confirmAtcButton.addEventListener('click', this.handlePublicCourseQuantity.bind(this));
    }

    if (this.confirmAtcButton) {
      this.confirmAtcButton.addEventListener('click', this.handleDateTimeFormat.bind(this));
    }

    if (this.querySelector('[data-suburb]')) {
      this.suburbSelect.addEventListener('change', this.handleSuburbChange.bind(this));
    } 
  }

  handleDateTimeFormat() {
    let dateTimeValue = document.querySelector('[data-datetime-format]').value;
    let dateTimeFormat = document.querySelector('[data-datetime]');
  
    let [date, time] = dateTimeValue.split('T');
    let [year, month, day] = date.split('-');
  
    let formattedDate = `${day}/${month}/${year.slice(2)}`;
    let formattedTime = this.formatTime(time);
  
    let format = `${formattedDate} ${formattedTime}`;
  
    dateTimeFormat.setAttribute('value', format);
  }

  handlePublicCourseQuantity() {
    let quantityValue = this.quantityVariant.getAttribute('data-variant-quantity');
    
    quantityValue = parseInt(quantityValue, 10);
    
    const quantityVariant = this.productVariants.find(variant => {
      const optionNumber = parseInt(variant.option1);
      return optionNumber === quantityValue;
    });

    if (quantityVariant) {
      this.currentVariantInput.value = quantityVariant.id
      this.quantityOption.value = quantityVariant.option1
    }
  }

  handlePrivateCourseQuantity () {
    const privateCourse = document.querySelector('[data-course-private]')
    const quantityInput = document.querySelector('input[name="quantity"]')
    const participants = document.querySelector('#tbe_field_9')

    if (privateCourse) {
      participants.addEventListener('input', function (event) {
        const participantValue = this.value;
  
        if (participantValue < 10) {
          quantityInput.setAttribute('value', 10);
        } else {
          quantityInput.setAttribute('value', participantValue);
        }
      });
    }
  }

  handleConfirmButton (event) {
    this.confirmAtcButton.removeAttribute('disabled');
    this.calendarPickerButton.removeAttribute('disabled');
  }

  handleStateChange(event) {
    const selectedOption = event.target.options[event.target.selectedIndex];
    const cityUrl = selectedOption.getAttribute('data-city-url'); 
    window.location.href = `${window.location.origin}${cityUrl}`;
  }

  handleSuburbChange(event) {
    const selectedOption = event.target.options[event.target.selectedIndex];
    this.updatePostcodeField(this.postCode, selectedOption.value.split(', ')[1])
  }

  handlePostcodeInput(event) {
    this.postCode = event.target.value;

    this.showError(false);

    if (this.postCode.length === 4 && /^\d{4}$/.test(this.postCode)) {
      this.validPostCode = true

      if (!this.isPostcodeAllowed(this.postCode)) {
        this.postcodeDiv.classList.add('not-available');
        this.showError(true, this.notAvailableMessage);

        this.removeAndResetLocalitiesSelector();
        this.validateInputs(false)

      } else {
        this.validPostCode = true
        this.suburb.classList.remove('is-hidden')

        this.lookupSuburb(this.postCode);

        const zone = this.findZone()

        this.validateInputs(true)

        if (zone) {
          const zoneVariant = this.productVariants.find(variant => {
            const title = variant.option1.toLowerCase().replaceAll(' ', '_')

            return title === zone
          })
          
          this.zoneVariant = zoneVariant

          this.currentVariantInput.value = zoneVariant.id
          this.zoneTitleInput.value = zoneVariant.option1
          this.zoneIdInput.value = zoneVariant.id
        } 
      }
    } else {
      this.validateInputs(false)
      this.removeAndResetLocalitiesSelector();
      this.showError(true, 'Please enter a valid 4-digit postcode.');
    }
  }

  findZone() {
    if (!this.postCode || !this.allowedPostCodes) return

    for (const key in this.allowedPostCodes) {
      if (this.allowedPostCodes[key].includes(Number(this.postCode))) {
        return key
      }
    }

    return null
  }

  isPostcodeAllowed(postcode) {
    return Object.values(this.allowedPostCodes).some(zone => zone.includes(parseInt(postcode, 10)));
  }

  lookupSuburb(postcode) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'address': postcode, 'componentRestrictions': {'country': 'AU'} }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results[0]) {
        const postalLocalities = results[0].postcode_localities;
        const suburb = results[0].address_components[1].long_name;
        if (postalLocalities && postalLocalities.length > 1) {
          this.handleMultipleLocalities(postcode, postalLocalities);
        } else {
          this.updatePostcodeField(postcode, suburb);
        }
      } else {
        this.removeAndResetLocalitiesSelector()
        this.showError(true, 'Invalid postcode or no results found.');
      }
    });
  }

  handleMultipleLocalities(postcode, localities) {
    this.updatePostcodeField(postcode, localities[0])
    
    let options = ''

    localities.forEach(locality => {
      options += `
        <option value="${postcode}, ${locality}">
          ${locality}
        </option>
      `
    });

    this.suburbSelect.innerHTML = options;
    this.suburb.classList.remove('is-hidden')
  }

  updatePostcodeField(postcode, suburb) {
    let options = ''

    options += `
      <option value="${postcode}, ${suburb}">
        ${suburb}
      </option>
    `

    this.suburbSelect.innerHTML = options;
    this.suburb.classList.remove('is-hidden')
  }

  showError(display, message = '') {
    this.errorMessage.innerHTML = message;
    this.errorMessage.style.display = display ? 'block' : 'none';
  }

  removeAndResetLocalitiesSelector() {
    this.suburb.classList.add('is-hidden')
    this.validPostCode = false

    this.zoneTitleInput.value = ''
    this.zoneIdInput.value = ''
  }

  fetchTimes () {
    fetch(`https://tinyhearts-booking.com/api/getInfo?pid=${tbe.product_id}`)
    .then(response => response.json())
    .then(data => {
      const bookingData = data.dates;
      console.log(bookingData, 'bookingData');
      const formData = data.form;
      this.initializeFlatpickr(bookingData, data.cutoff_days);
      this.initializeTimeSlots(bookingData);
      this.initializeForm(formData);
      this.handlePrivateCourseQuantity()
    });
  }

  initializeForm(formData) {
    let form_html = '';
    formData.map((field, index) => {
      var required = '';
      if (field.required == true) required = 'required';
      switch (field.type) {
        case 'textarea':
          form_html = form_html + `<div class="element"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          form_html += `</label><textarea rows="4" name='properties[${field.label}]' id="tbe_field_${index}" class="${required}" ${required}></textarea>`;
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
        case 'checkbox':
          form_html = form_html + `<div class="element"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          form_html += `</label>`;
          field.options.split(",").map((option) => {
            form_html += `<label class="option"><input type="${field.type}" name='properties[${field.label}][]' class="${required} tbe_field_${index}" data-cls="tbe_field_${index}" value="${option}" ${required}/> ${option}</label>`;
          })
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
        case 'radio':
          form_html = form_html + `<div class="element"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          form_html += `</label>`;
          field.options.split(",").map((option) => {
            form_html += `<label class="option"><input type="${field.type}" name='properties[${field.label}]' class="${required} tbe_field_${index}" data-cls="tbe_field_${index}" value="${option}" ${required}/> ${option}</label>`;
          })
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
        case 'select':
          form_html = form_html + `<div class="element"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          form_html += `</label>`;
          form_html += `<select id="tbe_field_${index}" name='properties[${field.label}]' class="${required}" ${required}>`;
          form_html += `<option value="" selected disabled hidden>${field.label}</option>`;
          field.options.split(",").map((option) => {
            form_html += `<option value="${option}">${option}</option>`;
          })
          form_html += `</select>`;
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
        default:
          form_html = form_html + `<div class="element"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          const addedAttr = field.type == "number" ? 'min="1" onwheel="this.blur()"' : '';
          form_html += `</label><input ${addedAttr} type="${field.type}" name='properties[${field.label}]' placeholder='${field.label}' id='tbe_field_${index}' class="${required}" ${required}/>`;
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
      }
    })
    document.getElementById("tbe-form-wrapper").innerHTML = form_html;
  }

  initializeFlatpickr(bookingData, cutoffdays) {
    const today = new Date(); 
    const afterCutoffDays = new Date(today.setDate(today.getDate() + cutoffdays)).toISOString();
    const availableDateTimes = bookingData
        .filter(booking => booking.booked < booking.capacity && new Date(booking.datetime+"+11:00").toISOString() > afterCutoffDays)
        .map(booking => booking.datetime);
    const limitedDateTimes = bookingData
        .filter(booking => (booking.capacity - booking.booked) < 10 && new Date(booking.datetime+"+11:00").toISOString() > afterCutoffDays && (booking.capacity > booking.booked))
        .map(booking => booking.datetime);
    const SoldOutDateTimes = bookingData
        .filter(booking => new Date(booking.datetime+"+11:00").toISOString() > afterCutoffDays && booking.capacity < booking.booked)
        .map(booking => booking.datetime);
    const allAvailableDateTimes = bookingData
        .filter(booking => new Date(booking.datetime+"+11:00").toISOString() > afterCutoffDays)
        .map(booking => booking.datetime);

    const uniqueAvailableDates = [...new Set(availableDateTimes.map(dt => dt.split('T')[0]))];
    const uniqueLimitedDates = [...new Set(limitedDateTimes.map(dt => dt.split('T')[0]))];
    const uniqueSoldOutDates = [...new Set(SoldOutDateTimes.map(dt => dt.split('T')[0]))];
    const uniqueAllAvailableDates = [...new Set(allAvailableDateTimes.map(dt => dt.split('T')[0]))];
    
    const hasSpecialDateInMonth = (month, year) => {
      return uniqueAvailableDates.some(dateStr => {
        const date = new Date(dateStr);
        return date.getMonth() === month && date.getFullYear() === year;
      });
    };

    const checkComingSoon = (currentMonth, currentYear) => {
      const displayedDate = new Date(currentYear, currentMonth);

      // Reference date (e.g., today)
      const now = new Date();
      const refDate = new Date(now.getFullYear(), now.getMonth());

      // Difference in months
      const diffInMonths = (displayedDate.getFullYear() - refDate.getFullYear()) * 12
                         + (displayedDate.getMonth() - refDate.getMonth());

      // No courses from 2027, so every empty month shows Sold out
      document.querySelector('#available_dates').classList.add('soldout_active');
      document.querySelector('#available_dates').classList.remove('comingsoon_active');
    }

    let prevMonthObserver = null;
    
    const enablePrevMonthButton = (instance) => {
      // Enable previous month button if we're past the minDate month
      const minDate = new Date();
      minDate.setDate(minDate.getDate() + 1); // minDate is tomorrow
      const minMonth = minDate.getMonth();
      const minYear = minDate.getFullYear();
      const currentMonth = instance.currentMonth;
      const currentYear = instance.currentYear;
      
      // Only enable if current displayed month is after the minDate month
      const isPastMinDate = (currentYear > minYear) || 
                           (currentYear === minYear && currentMonth > minMonth);
      
      const prevMonthBtn = instance.calendarContainer.querySelector('.flatpickr-prev-month');
      
      if (isPastMinDate && prevMonthBtn) {
        // Remove disabled class and styles
        prevMonthBtn.classList.remove('flatpickr-disabled');
        prevMonthBtn.style.pointerEvents = 'auto';
        prevMonthBtn.style.opacity = '1';
        prevMonthBtn.style.cursor = 'pointer';
        if (prevMonthBtn.disabled !== undefined) {
          prevMonthBtn.disabled = false;
        }
        
        // Set up MutationObserver to keep it enabled
        if (!prevMonthObserver) {
          prevMonthObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && 
                  (mutation.attributeName === 'class' || mutation.attributeName === 'disabled')) {
                const btn = mutation.target;
                // Check if we're still past minDate
                const currentMonth = instance.currentMonth;
                const currentYear = instance.currentYear;
                const isPastMin = (currentYear > minYear) || 
                                 (currentYear === minYear && currentMonth > minMonth);
                
                if (isPastMin && (btn.classList.contains('flatpickr-disabled') || btn.disabled)) {
                  // Re-enable if we're past minDate
                  btn.classList.remove('flatpickr-disabled');
                  btn.style.pointerEvents = 'auto';
                  btn.style.opacity = '1';
                  btn.style.cursor = 'pointer';
                  if (btn.disabled !== undefined) {
                    btn.disabled = false;
                  }
                }
              }
            });
          });
          
          prevMonthObserver.observe(prevMonthBtn, {
            attributes: true,
            attributeFilter: ['class', 'disabled']
          });
        }
      } else if (!isPastMinDate && prevMonthObserver) {
        // Clean up observer if we're back at minDate month
        prevMonthObserver.disconnect();
        prevMonthObserver = null;
      }
    }

    const advanceToAvailableMonth = (instance, maxMonths = 24, currentAttempt = 0) => {
      if (currentAttempt >= maxMonths) {
        return; // Safety limit to prevent infinite loops
      }

      const availableDatesEl = document.querySelector('#available_dates');
      if (availableDatesEl && (availableDatesEl.classList.contains('soldout_active') || availableDatesEl.classList.contains('comingsoon_active'))) {
        instance.changeMonth(1);
        // Use setTimeout to allow the month change to complete before checking again
        setTimeout(() => {
          const newYear = instance.currentYear;
          const newMonth = instance.currentMonth;
          if (hasSpecialDateInMonth(newMonth, newYear)) {
            availableDatesEl.classList.remove('soldout_active');
            availableDatesEl.classList.remove('comingsoon_active');
            // Enable prev button after finding available month
            setTimeout(() => {
              enablePrevMonthButton(instance);
            }, 150);
          } else {
            checkComingSoon(newMonth, newYear);
            // Recursively check the next month
            advanceToAvailableMonth(instance, maxMonths, currentAttempt + 1);
          }
        }, 100);
      } else {
        // Enable prev month button when we stop advancing
        setTimeout(() => {
          enablePrevMonthButton(instance);
        }, 150);
      }
    }

    const pickerObj = this;

    flatpickr("#calendarContainer", {
      inline: true,
      dateFormat: "Y-m-d",
      minDate: new Date().fp_incr(1),
      enable: uniqueAvailableDates,
      disable: [
        function(date) {
          const dateString = date.toISOString().split('T')[0];
          return !uniqueAvailableDates.includes(dateString);
        }
      ],
      onChange: (selectedDates) => {
        this.selectedDate = selectedDates[0];  
        this.updateAvailableTimes(this.selectedDate, bookingData);
      },
      onDayCreate: function(dObj, dStr, fp, dayElem) {
        const date = fp.formatDate(dayElem.dateObj, "Y-m-d");
        if (uniqueLimitedDates.includes(date)) {
          dayElem.classList.add("limited-date");
        }
        if (uniqueSoldOutDates.includes(date) && !uniqueAllAvailableDates.includes(date)) {
          dayElem.classList.add("soldOut-date");
        }
      },
      onReady: function(selectedDates, dateStr, instance) {        
        const currentYear = instance.currentYear;
        const currentMonth = instance.currentMonth;
        if (hasSpecialDateInMonth(currentMonth, currentYear)) {
          document.querySelector('#available_dates').classList.remove('soldout_active');
          document.querySelector('#available_dates').classList.remove('comingsoon_active');
        }else{          
          checkComingSoon(currentMonth, currentYear);
          // Auto-advance to next available month if current month is sold out or coming soon
          advanceToAvailableMonth(instance);
        }
        // Enable previous month button after calendar is ready (with delay to ensure flatpickr has finished)
        setTimeout(() => {
          enablePrevMonthButton(instance);
        }, 150);
      },
      onMonthChange: function(selectedDates, dateStr, instance) {
        const currentYear = instance.currentYear;
        const currentMonth = instance.currentMonth;
        if (hasSpecialDateInMonth(currentMonth, currentYear)) {
          document.querySelector('#available_dates').classList.remove('soldout_active');
          document.querySelector('#available_dates').classList.remove('comingsoon_active');
        }else{
          checkComingSoon(currentMonth, currentYear);
          // Don't auto-advance on month change - let users navigate freely
        }
        // Always check and enable prev button after month change (if past minDate)
        setTimeout(() => {
          enablePrevMonthButton(instance);
        }, 50);
      },
      onYearChange: function(selectedDates, dateStr, instance) {
        const currentYear = instance.currentYear;
        const currentMonth = instance.currentMonth;
        if (hasSpecialDateInMonth(currentMonth, currentYear)) {
          document.querySelector('#available_dates').classList.remove('soldout_active');
          document.querySelector('#available_dates').classList.remove('comingsoon_active');
        }else{
          checkComingSoon(currentMonth, currentYear);
          // Don't auto-advance on year change - let users navigate freely
        }
        // Always check and enable prev button after year change (if past minDate)
        setTimeout(() => {
          enablePrevMonthButton(instance);
        }, 50);
      }      
    });        
  }
  
  initializeTimeSlots(bookingData) {
    const uniqueSlots = new Set();

    bookingData.forEach(booking => {
      const time = booking.datetime.split('T')[1].substring(0, 5);
      uniqueSlots.add(time);
    });

    const sortedUniqueSlots = Array.from(uniqueSlots).sort((a, b) => {
      const timeA = this.convertTo24Hour(a);
      const timeB = this.convertTo24Hour(b);
      return timeA - timeB;
    });

    const timeSlotsContainer = document.getElementById('timeSelection');
    timeSlotsContainer.innerHTML = '';

    sortedUniqueSlots.forEach(time => {
      const label = document.createElement('label');
      const radioInput = document.createElement('input');
      const span = document.createElement('span');
      span.appendChild(document.createTextNode(` ${this.formatTime(time)}`));
      radioInput.type = 'radio';
      radioInput.name = 'timeSlot';
      radioInput.value = time;
      radioInput.disabled = true;
      label.appendChild(radioInput);
      label.appendChild(span);
      timeSlotsContainer.appendChild(label);
   
      radioInput.addEventListener('change', () => {
        this.selectedTime = radioInput.value;  
        if (this.selectedDate && this.selectedTime) {
          const selectedDateTime = `${this.selectedDate.toISOString().split('T')[0]}T${this.selectedTime}`;
          const formattedDateTime = `${this.formatDate(this.selectedDate)} — ${this.formatTime(this.selectedTime)}`;

          document.querySelector('[data-date-time-slot]').innerHTML = formattedDateTime;
        }
      });
    });

    this.timeSlotRadios = document.querySelectorAll('input[name="timeSlot"]')

    this.timeSlotRadios.forEach(radio => {
      radio.addEventListener('change', this.validateInputs.bind(this)); 
    });
  }

  validateInputs (display) {
    const hasTimeSlotSelected = Array.from(this.timeSlotRadios).some(input => input.checked);

    const confirmButton = document.querySelector('[data-confirm-button]')
    const confirmAtcButton = document.querySelector('[data-confirm-atc-button]')
    const calendarPickerButton = document.querySelector('[data-calendar-picker]')
    
    if (this.postcodeDiv) {
      if (display === true) {
        calendarPickerButton.removeAttribute('disabled');
      } else {
        calendarPickerButton.setAttribute('disabled', true);
      }
    }

    if (hasTimeSlotSelected) {
      confirmAtcButton.removeAttribute('disabled');
      confirmButton.removeAttribute('disabled');
    } else {
      confirmButton.setAttribute('disabled', true);
      confirmAtcButton.setAttribute('disabled', true);
    }
  }

  updateAvailableTimes(selectedDate, bookingData) {
    const timeSlotsContainer = document.getElementById('timeSelection');
    const inputs = timeSlotsContainer.querySelectorAll('input[type="radio"]');
    inputs.forEach(input => {
      input.checked = false
      input.disabled = true
    }); 

    if (!selectedDate) return;

    const timezoneOffset = 11; 
    const adjustedDate = new Date(selectedDate.getTime() + timezoneOffset * 3600 * 1000);
    const selectedDateString = adjustedDate.toISOString().split('T')[0];

    const timesForDate = bookingData
      .filter(booking => booking.datetime.startsWith(selectedDateString))
      .map(booking => ({
        time: booking.datetime.split('T')[1].substring(0, 5),
        isAvailable: booking.booked < booking.capacity
      }));

    inputs.forEach(input => {
      const timeSlotAvailable = timesForDate.find(time => time.time === input.value && time.isAvailable);
      input.disabled = !timeSlotAvailable;
      input.addEventListener('change', () => {
        if (input.checked) {
          const selectedDateTime = `${selectedDateString}T${input.value}`;
          document.querySelector('[data-datetime-format]').value = selectedDateTime; 
        }
      });
    });

    this.validateInputs(true);
  }

  convertTo24Hour(time) {
    const [hours, minutes] = time.split(':');
    return parseInt(hours) * 100 + parseInt(minutes); 
  }

  formatTime(timeString) {
    const [hours, minutes] = timeString.split(':');
    const hoursInt = parseInt(hours);
    const period = hoursInt >= 12 ? 'PM' : 'AM';
    const formattedHours = ((hoursInt + 11) % 12 + 1); 
    return `${formattedHours}:${minutes} ${period}`;
  }

  getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    }
  }
  
  formatDate(date) {
    const day = date.getDate();
    const monthName = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}${this.getOrdinalSuffix(day)}, ${monthName} ${year}`;
  }
}

customElements.define('zone-picker', ZonePicker);
